var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartreport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H28.4C33.9229 0 38.4 4.47715 38.4 10V28C38.4 33.5228 33.9228 38 28.4 38H9.99999C4.47715 38 0 33.5228 0 28V10Z",
    fill: "#D8EAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6666 10.6667H13.9999C13.5579 10.6667 13.134 10.8423 12.8214 11.1548C12.5088 11.4674 12.3333 11.8913 12.3333 12.3334V25.6667C12.3333 26.1087 12.5088 26.5326 12.8214 26.8452C13.134 27.1578 13.5579 27.3334 13.9999 27.3334H23.9999C24.4419 27.3334 24.8659 27.1578 25.1784 26.8452C25.491 26.5326 25.6666 26.1087 25.6666 25.6667V15.6667L20.6666 10.6667Z",
    stroke: "#004276",
    strokeWidth: 0.833333
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 10.6667V15.6667H25.6667",
    stroke: "#004276",
    strokeWidth: 0.833333
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3334 19.8333H15.6667",
    stroke: "#004276",
    strokeWidth: 0.833333
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3334 23.1667H15.6667",
    stroke: "#004276",
    strokeWidth: 0.833333
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 16.5H15.6667",
    stroke: "#004276",
    strokeWidth: 0.833333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartreport);
export default __webpack_public_path__ + "static/media/smart report.b9ba0cfeaf86648cd251236fb86440ba.svg";
export { ForwardRef as ReactComponent };